import { createDeveloperPortalSdk } from '@keboola/api-client/sdk/developerPortal';

import { persistTokens, readPersistedTokens } from './auth/persistence';

/**
 * apps-api's base URL; defaults to production.
 *
 * - `connect-src` in `index.html` must allow it (currently `https://*.keboola.com`).
 */
const BASE_URL = import.meta.env.VITE_APPS_API_URL ?? 'https://apps-api.keboola.com';

/**
 * The app's single Developer Portal client.
 *
 * - Must stay a singleton: a second client gets its own 401-refresh latch and parallel refreshes
 *   invalidate each other's tokens.
 * - Not `ProjectApiProvider`: apps-api is no Keboola stack. See `packages/api-client/AGENTS.md`.
 */
export const { api, session } = createDeveloperPortalSdk({
  baseUrl: BASE_URL,
  tokens: readPersistedTokens(),
  onTokensChange: persistTokens,
  // Navigation on expiry lives in AuthProvider, which subscribes to the session.
});
